import { Lightning as lng } from '@lightningjs/sdk';
import { OnScreenKeyboard } from './OnScreenKeyboard';
import { defaultOptions } from './helpers/defaultOptions';
import { Theme } from '../../config/theme';

export const keyboardOrientation = {
  HORIZONTAL: 'hor',
  VERTICAL: 'ver',
};
Object.freeze(keyboardOrientation);

export class AtvKeyboard extends lng.Component {
  static _template() {
    return {
      orientation: keyboardOrientation.HORIZONTAL,
      zIndex: 1000,
      mountY: 1,
      x: 0,
      y: h => h,
      h: h => h / 3,
      w: w => w,
      rect: true,
      color: 0xff1c242b,
      Keyboard: {
        mount: 0.5,
        x: w => w * 0.5,
        y: h => h * 0.5,
        w: w => w,
        h: h => h,
        color: 0x00000000,
        type: OnScreenKeyboard,
        signals: {
          onFinished: true,
        },
        passSignals: { onInputChanged: true },
      },
    };
  }

  _build() {
    this._transitionOpt = {
      duration: 0.75,
      delay: 0.15,
      timingFunction: 'ease-in-out',
    };
    const _horizontalSpacing = 5;
    const _keyWidth = 150;
    this.tag('Keyboard').config = {
      layoutOptions: {
        columns: this.orientation === keyboardOrientation.HORIZONTAL ? defaultOptions.layoutOptions.columns : 4,
        pyramid: this.orientation === keyboardOrientation.HORIZONTAL ? defaultOptions.layoutOptions.pyramid : false,
      },
      styling: {
        horizontalSpacing: _horizontalSpacing,
        verticalSpacing: 5,
      },
      keyOptions: {
        w: _keyWidth,
        h: 80,
        label: {
          fontSize: 50,
        },
        backgroundColors: {
          ...Theme.Colors.Keyboard.Background,
        },
      },
      Space: {
        w: _keyWidth * 2 + _horizontalSpacing,
      },
    };
    this.isShown = false;
  }

  _firstActive() {
    this.screenHeight = this.finalY;
    this.fixPosition();
  }

  fixPosition() {
    if (this.orientation === keyboardOrientation.HORIZONTAL) {
      this.patch({ y: this.screenHeight + 400, w: w => w, h: h => h / 3 }); // hack needed since transitions dont seem to work on 'y: h => h', also this.h is not set yet on firstActive
    } else if (this.orientation === keyboardOrientation.VERTICAL) {
      this.patch({ x: -800, w: w => w / 3, h: h => h });
    }
  }

  set transitionOpt(val) {
    this._transitionOpt = val;
  }

  set inputField(val) {
    this.tag('Keyboard').inputField = val;
  }

  set keyboardColors({ color = undefined, backgroundColors = undefined, labelColors = undefined }) {
    if (color) this.color = color;
    if (backgroundColors) {
      let keyOptions = this.tag('Keyboard').config.keyOptions;
      keyOptions.backgroundColors = backgroundColors;
      this.patchKeyboardConfig({ keyOptions });
    }
    if (labelColors) {
      let keyOptions = this.tag('Keyboard').config.keyOptions;
      keyOptions.labelColors = labelColors;
      this.patchKeyboardConfig({ keyOptions });
    }
  }

  set keyboardConfig(conf) {
    this.patchKeyboardConfig(conf);
  }

  get keyboardConfig() {
    return this.tag('Keyboard').config;
  }

  patchKeyboardConfig(conf) {
    this.tag('Keyboard').config = {
      ...this.tag('Keyboard').config,
      ...conf,
    };
  }

  _getFocused() {
    return this.tag('Keyboard');
  }

  _handleBack() {
    this.hide();
    return true;
  }

  onFinished() {
    //lightning does not allow to capture and also pass signals so have to manually refire
    this.hide();
    this.signal('onFinished');
  }

  show() {
    if (this.isShown || this.screenHeight === undefined) return;

    if (this.orientation === keyboardOrientation.HORIZONTAL) {
      this.setSmooth('y', this.screenHeight, this._transitionOpt);
    } else if (this.orientation === keyboardOrientation.VERTICAL) {
      this.setSmooth('x', 0, this._transitionOpt);
    }
    this.isShown = true;
  }

  hide() {
    if (!this.isShown || this.screenHeight === undefined) return;

    if (this.orientation === keyboardOrientation.HORIZONTAL) {
      this.setSmooth('y', this.screenHeight + this.finalH, this._transitionOpt);
    } else if (this.orientation === keyboardOrientation.VERTICAL) {
      this.setSmooth('x', -this.finalW, this._transitionOpt);
    }
    this.isShown = false;
  }
}
